export const GET_PENDING_REQUESTS = 'GET_PENDING_REQUESTS';
export const GET_PENDING_REQUEST = 'GET_PENDING_REQUEST';
export const SET_PENDING_REQUEST = 'SET_PENDING_REQUEST';
export const DELETE_ALL_PENDING_REQUESTS = 'DELETE_ALL_PENDING_REQUESTS';
export const DELETE_PENDING_REQUEST = 'DELETE_PENDING_REQUEST';